//
//
//
//
//
//
//

require('@/assets/data_database_icon_177024.png');
import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import LineageReport from './LineageReport.vue';
export default {
  name: 'ReportTabLineage',
  components: {
    LineageReport: LineageReport
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    }
  },
  watch: {
    'item.datasources': function itemDatasources(newVal, oldVal) {
      console.log('change datasources');
      this.loadLineage();
    },
    'item.object_name': function itemObject_name(newVal, oldVal) {
      console.log('change object_name');
      this.loadLineage();
    }
  },
  computed: {},
  data: function data() {
    return {
      dataset: {},
      reports: {},
      data_lineage: {
        dataset: {}
      },
      key_lineage: 1
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.loadLineage();
    //this.detDataset()
  },
  methods: {
    loadLineage: function loadLineage() {
      this.key_lineage += 1;
      if (this.item.datasources) {
        this.item.datasources.forEach(function (element) {
          element.type = 'DATASOURCE';
        });
        var element = Object.assign({}, this.item);
        element.type = 'REPORT';
        this.data_lineage = {
          dataset: element,
          // report
          tables: this.item.datasources,
          // datasources
          reports: [] // conexiones
        };
        console.log('data_lineage', this.data_lineage);
      }
    }
  }
};